import {Component, Input} from '@angular/core';
import {InfoModalComponent} from "../../views/modal/info_modal.component";
import {AlertComponent} from "../../views/modal/alert.component";
import {ModalService} from "../../views/modal/base_modal.component";
import {TranslateService} from "../../translate/translate.service";
import {FilterFormService} from "../../views/filter_form/filter_form.service";
import {HelperService} from "../../lib/helper.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AccessorService} from "./accessor.service";
import {ChartParams} from "../../views/chart/chart.component";

@Component({
	template: `
		<info-modal [title]="title" (onOk)="ok()">
			<loading [isLoad]="!stats"></loading>
			
			<div class="row">
				<div class="col-md-4">
					<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'"></chart>
				</div>
	
				<div class="col-md-8">
					<div class="form-group">
						{{ 'adminstat.mails.mailer.date filter' | translate }}
						<select class="form-control" [(ngModel)]="type" [ngModelOptions]="{standalone: true}">
							<option *ngFor="let val of ['all', 'now', 'yesterday', 'prevWeek', 'prevMonth', 'last7day', 'last30day', 'other']"
									value="{{ val }}" [selected]="val == dateFilter">
								{{ 'adminstat.common.interval.' + val | translate }}
							</option>
						</select>
	
						<table>
							<tr [style.display]="type != 'other' ? 'none' : null">
								<td>
									<datepicker [(ngModel)]="start" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
									<datepicker [(ngModel)]="end" [ngModelOptions]="{standalone: true}" [format]="'DD-MM-YYYY'"></datepicker>
								</td>
							</tr>
						</table>
	
						<br><br>
	
						<button type="button" class="btn btn-success" (click)="applyFilters()" [sextant]="'btnApplyFilters'">{{ 'adminstat.common.Apply' | translate }}</button>
						<button type="button" class="btn btn-link" style="color:red;" (click)="resetFilters()">{{ 'adminstat.common.Reset filters' | translate }}</button>

						<button type="button" class="btn btn-warning" (click)="downloadTopSites()" style="float:right;">{{ 'adminstat.support.accessor.export csv top sites' | translate }}</button>
					</div>
	
					<br><br>
	
					<table class="table" *ngIf="stats && stats.length > 0">
						<thead>
							<th>{{ 'adminstat.support.accessor.accessor' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.categorized' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.defered' | translate }}</th>
							<th>{{ 'adminstat.support.accessor.viewed' | translate }}</th>
						</thead>
	
						<tbody>
							<tr *ngFor="let stat of stats">
								<td>
									{{ stat.email }}
								</td>
		
								<td>
									{{ stat.setCategoryCount }}
								</td>
		
								<td>
									{{ stat.deferCount }}
								</td>
		
								<td>
									{{ stat.totalCount }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</info-modal>
	`
})
export class AccessorStatsModalComponent extends InfoModalComponent {
	stats;

	type: string = 'all';
	start: any;
	end: any;

	chart = new ChartParams();

	constructor(
		public activeModal: NgbActiveModal, 
		public helper: HelperService,
		public translate: TranslateService,
		public modalService: ModalService,
		public filter: FilterFormService,
		public service: AccessorService
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}

	updateChartData() {
		this.chart.data = this.stats.reduce(function(accessors, accessor) {
			accessors.push(
				[
					accessor.email,
					accessor.totalCount
				]
			);
			return accessors;
		}, []);
	}
	
	async applyFilters() {
		this.stats = null;
		
		let dateFilterParams: any = {
			accessor: {
				start: this.start,
				end: this.end,
				type: this.type
			}	
		};
		
		this.filter.filterParams.accessorDateFilter = this.filter.getApplyFilters({ dateFilterParams: dateFilterParams }).dateFilterParams.accessor;
		
		let options = { dateFilter: this.filter.filterParams.accessorDateFilter.type, start: this.filter.filterParams.accessorDateFilter.start, end: this.filter.filterParams.accessorDateFilter.end };
		
		const { stats } = await this.service.getStats(options).toPromise();

		this.stats = stats || [];
		this.updateChartData();
	}
	
	async resetFilters() {
		this.type = 'all';
		this.stats = null;
		this.stats = await this.service.getStats({}).toPromise() || [];

		this.filter.filterParams.accessorDateFilter = { type: this.type, start: null, end: null };
		
		this.updateChartData();
	}
	
	downloadTopSites() {
		let params: string = this.helper.getUrlParams(this.filter.filterParams);

		window.location.href = `${this.service.dp.baseRoute}/accessor2/top_download?${params}`;

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
}
